import React, { useContext, useRef } from 'react';

import PropTypes from 'prop-types';
import {
  Onboarding,
  OnboardingContext,
  OnboardingSubtitle,
  OnboardingTitle,
} from 'registration/containers/Onboarding';

import { Input } from 'shared/components/ihcl/input';
import { Center } from 'shared/components/ihcl/positioning';

import parseFullName from '../../helpers/parseFullName';
import OnboardingTestimonial from './OnboardingTestimonial';

const OnboardingName = ({
  nextAction = null,
  previousAction = null,
  stepNumber,
}) => {
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const nextActionButtonRef = useRef(null);
  if (!onboardingData || Object.keys(onboardingData).length < 1) {
    return null;
  }
  const {
    errors,
    full_name: fullName,
    first_name: firstName,
    last_name: lastName,
  } = onboardingData;

  if (fullName && (!firstName || !lastName)) {
    const [parsedFirstName, parsedLastName] = parseFullName(fullName);
    if (parsedFirstName && parsedLastName) {
      setOnboardingData({
        ...onboardingData,
        first_name: parsedFirstName,
        last_name: parsedLastName,
      });
    }
  }

  let nameError = null;
  if (errors && errors.name && Array.isArray(errors.name)) {
    nameError = errors.name.join('; ');
  }

  const setName = (name, errorMessage) => {
    const [parsedFirstName, parsedLastName] = parseFullName(name);
    const nameObj = {
      full_name: name,
    } as {
      full_name: string;
      first_name?: string;
      last_name?: string;
      errors?: { name: string[] };
    };
    if (parsedLastName) {
      nameObj.first_name = parsedFirstName;
      nameObj.last_name = parsedLastName;
      setOnboardingData({
        ...onboardingData,
        ...nameObj,
      });
    } else {
      setOnboardingData({
        ...onboardingData,
        ...nameObj,
        errors: {
          name: [errorMessage],
        },
      });
    }
  };

  return (
    <Onboarding
      currentStep={stepNumber}
      isNextDisabled={!firstName || !lastName}
      nextAction={nextAction}
      nextActionButtonRef={nextActionButtonRef}
      previousAction={previousAction}
      stepKeys={['first_name', 'last_name']}
      stepName="Name"
    >
      <Center>
        <OnboardingTitle>What&apos;s your name?</OnboardingTitle>
        <Center>
          <OnboardingSubtitle>
            Kick back and relax while hospitals compete for you.
          </OnboardingSubtitle>
          <form
            action="#"
            onSubmit={(evt) => {
              evt.preventDefault();
              if (
                parseFullName(fullName).length >= 2 &&
                nextActionButtonRef &&
                nextActionButtonRef.current
              ) {
                nextActionButtonRef.current.click();
              }
            }}
          >
            <Input
              id="fullName"
              value={fullName}
              type="text"
              label="Your first & last name"
              onChange={(evt) => {
                setName(evt.target.value, null);
              }}
              onBlur={(evt) => {
                const parsedFullName = parseFullName(evt.target.value);
                if (parsedFullName.length < 2) {
                  setName(
                    evt.target.value,
                    'Please enter your first and last name.'
                  );
                }
              }}
              error={!!nameError}
              caption={nameError}
            />
          </form>
          <OnboardingTestimonial
            author="Heather Banks, RN"
            attributionLine="#humbleBrag from:"
            quote="Great support system throughout the entire process of prepping for interviews and accepting a job offer!"
          />
        </Center>
      </Center>
    </Onboarding>
  );
};
OnboardingName.propTypes = {
  nextAction: PropTypes.string,
  previousAction: PropTypes.string,
  stepNumber: PropTypes.number.isRequired,
};

export default OnboardingName;
